const getters = {
	sidebar: state => state.app.sidebar,
	device: state => state.app.device,
	token: state => state.user.token,
	avatar: state => state.user.avatar,
	name: state => state.user.name,
	userId: state => state.user.userId,
	roles: state => state.user.roles,
	addRouters: state => state.permission.addRouters,
	routers: state => state.permission.routers,
	menus: state => state.permission.menus,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js